import { Heading, Text, Flex, Button, Center, AspectRatio, Box, useBreakpointValue, Container } from '@chakra-ui/react';
import NextImage from 'next/image';
import Link from 'next/link';
import { FC } from 'react';

import PresentationHeadingImage from '@/assets/images/researchers/bg.png';

export const ResearchersHeader: FC = () => {
  const imagePosition = useBreakpointValue(
    { base: '-950px', sm: '-600px', lg: 'center' },
    { ssr: true, fallback: 'center' }
  );

  return (
    <Center mt={-16} bgColor="black" position="relative">
      <Box position="absolute" w="full" bgColor="black" overflow="hidden" bg="gradientBackground2">
        <AspectRatio objectFit="cover" h={{ base: '786px', sm: '610px' }} w="full" ratio={1905 / 530}>
          <NextImage
            objectPosition={imagePosition}
            quality={90}
            layout="fill"
            priority={true}
            src={PresentationHeadingImage}
            alt="Hero cover"
          />
        </AspectRatio>
      </Box>
      <Container position="relative" mt={16} h={{ base: '716px', sm: '542px' }} px={{ base: 5, md: 10, lg: 5 }}>
        <Flex
          py={6}
          width={{ base: 'full', lg: '67%' }}
          h="full"
          flexDirection="column"
          justifyContent={{ base: 'flex-start', sm: 'center' }}
        >
          <Heading fontSize={{ base: '4xl', md: '5xl' }} color="white">
            Share Your Science with the World!
          </Heading>
          <Text fontSize={{ base: 'xl' }} mt={6} color="white">
            Now you can share your conference presentations with a larger audience of researchers around the world!
            <br />
            <br />
            The Underline Video Platform makes your video, paper, abstract, poster available to global University
            Libraries. With our unique ‘container’ for continued engagement – others can find your talk, contact you,
            ask questions and begin a collaboration.
          </Text>
          <Flex flexDirection={{ base: 'column', sm: 'row' }} gap={4} mt={10}>
            <Link href="/submit">
              <Button backdropFilter="blur(9px)" variant="glass" color="white" alignSelf="flex-start">
                Submit your presentation
              </Button>
            </Link>
            <Link href="/contact-us/support">
              <Button
                variant="solid"
                bgColor="gray.50"
                color="black"
                _hover={{ bgColor: 'white', textDecoration: 'underline' }}
                alignSelf="flex-start"
              >
                Contact us
              </Button>
            </Link>
          </Flex>
        </Flex>
      </Container>
    </Center>
  );
};
